<script setup>
import SelectTranslation from "./SelectTranslation.vue";
import { computed, inject, ref} from "vue";

import stLogo from "../assets/logo.svg";
import ScanInstruction from '@/components/ScanInstruction.vue'

const emit = defineEmits(["instruction-toggle", "instruction-start-scan"]);

const showInstruction = ref(false);

const brandingTheme = inject("brandingTheme");
const hideHeader = inject("noHeader");

const mainLogo = computed(() => (brandingTheme.value?.logo ? brandingTheme.value.logo : stLogo));

function toggleInstruction() {
  showInstruction.value = !showInstruction.value;
  emit("instruction-toggle", showInstruction.value);
}

function handleClose() {
  showInstruction.value = false;
  emit("instruction-start-scan");
}
</script>

<template>
<div v-if="!hideHeader" class="relative z-[99] flex h-10.5 items-center justify-between bg-(--background) px-3 py-0">
  <img :src="mainLogo" class="max-h-9 max-w-32" width="auto" height="36" alt="Scantrust Logo" crossorigin />
  <div class="flex items-center gap-5">
    <div class="z-10" @click.stop="toggleInstruction">
      <svg class="fill-(--text)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 22" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M17.1855 0H2.14819C0.96139 0 0 0.898557 0 2.00846V16.069C0 17.1789 0.96139 18.0775 2.14819 18.0775H6.44456L9.66663 21.0904L12.8891 18.0775H17.1855C18.3723 18.0775 19.3333 17.1789 19.3333 16.069V2.00846C19.3333 0.898557 18.3723 0 17.1855 0ZM8.59274 14.0606H10.7409V16.0691H8.59274V14.0606ZM12.9589 8.29061L11.9975 9.21465C11.2242 9.93789 10.7409 10.5451 10.7409 12.0518H8.59269V11.5496C8.59269 10.4401 9.07603 9.43567 9.84936 8.70759L11.1864 7.44215C11.5731 7.08053 11.8148 6.5783 11.8148 6.02598C11.8148 4.91608 10.8534 4.01708 9.66657 4.01708C8.47977 4.01708 7.51838 4.91608 7.51838 6.02598H5.37019C5.37019 3.80618 7.29297 2.00862 9.66657 2.00862C12.0406 2.00862 13.9629 3.80618 13.9629 6.02598C13.9629 6.9096 13.5816 7.70798 12.9589 8.29061Z" />
      </svg>
    </div>
    <SelectTranslation />
  </div>
</div>

<ScanInstruction v-if="showInstruction" :visible="showInstruction" @close="handleClose" />
</template>
